import React from 'react';

interface AppStoreButtonsProps {
  appStoreUrl?: string;
  googlePlayUrl?: string;
  className?: string;
}

const AppStoreButtons: React.FC<AppStoreButtonsProps> = ({ 
  appStoreUrl = 'https://apps.apple.com/app/spin-the-truth/id6757371160',
  googlePlayUrl = 'https://play.google.com/store/apps/details?id=your.app.id',
  className = ''
}) => {
  const handleAppStoreClick = () => {
    if ((window as any).gtag) {
      (window as any).gtag('event', 'click_app_store', {
        event_category: 'engagement',
        event_label: 'app_store_button',
        value: 1,
      });
    }
    window.open(appStoreUrl, '_blank');
  };

  const handleGooglePlayClick = () => {
    window.open(googlePlayUrl, '_blank');
  };

  return (
    <div className={`flex flex-row sm:flex-col items-center justify-center gap-8 sm:gap-3 ${className}`}>
      {/* App Store Button */}
      <a
        href={appStoreUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-block hover:opacity-90 transition-opacity cursor-pointer sm:w-full"
        onClick={(e) => {
          e.preventDefault();
          handleAppStoreClick();
        }}
      >
        <div className="flex items-center bg-black text-white rounded-xl sm:rounded-lg px-6 py-4 sm:px-3 sm:py-2.5 shadow-md hover:shadow-lg transition-shadow min-w-[240px] sm:w-full h-[80px] sm:h-[45px] justify-start sm:justify-center">
          {/* Apple Logo */}
          <svg className="w-10 h-10 sm:w-5 sm:h-5 mr-4 sm:mr-2.5 flex-shrink-0" viewBox="0 0 24 24" fill="white">
            <path d="M17.05 20.28c-.98.95-2.05.88-3.08.4-1.09-.5-2.08-.48-3.24 0-1.44.62-2.2.44-3.06-.4C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z"/>
          </svg>
          <div className="flex flex-col items-start justify-center">
            <span className="text-xs sm:text-[8px] leading-tight font-normal text-white" style={{ letterSpacing: '0.3px' }}>Download on the</span>
            <span className="text-xl sm:text-xs font-semibold leading-tight text-white mt-0.5">App Store</span>
          </div>
        </div>
      </a>


      {/* Google Play Button */}
      {/* <a
        href={googlePlayUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-block hover:opacity-90 transition-opacity cursor-pointer sm:w-full"
        onClick={(e) => {
          e.preventDefault();
          handleGooglePlayClick();
        }}
      >
        <div className="flex items-center bg-black text-white rounded-xl sm:rounded-lg px-6 py-4 sm:px-3 sm:py-2.5 shadow-md hover:shadow-lg transition-shadow min-w-[240px] sm:w-full h-[80px] sm:h-[45px] justify-start sm:justify-center">
          <svg className="w-10 h-10 sm:w-5 sm:h-5 mr-4 sm:mr-2.5 flex-shrink-0" viewBox="0 0 24 24" fill="none">
            <path d="M1.5 4.87L13.69 12L1.5 19.13V4.87Z" fill="#00D9FF"/>
            <path d="M1.5 19.13L13.69 12L6.05 21.34L1.5 19.13Z" fill="#00F076"/>
            <path d="M6.05 21.34L13.69 12L20.16 12L6.05 21.34Z" fill="#FFCE00"/>
            <path d="M20.16 12L13.69 12L6.05 4.46L20.16 12Z" fill="#FF3A44"/>
            <path d="M6.05 4.46L13.69 12L1.5 4.87L6.05 4.46Z" fill="#00F076"/>
          </svg>
          <div className="flex flex-col items-start justify-center">
            <span className="text-xs sm:text-[8px] leading-tight font-normal text-white uppercase" style={{ letterSpacing: '0.5px' }}>GET IT ON</span>
            <span className="text-xl sm:text-xs font-semibold leading-tight text-white mt-0.5">Google Play</span>
          </div>
        </div>
      </a> */}


    </div>
  );
};

export default AppStoreButtons;
